import { useContext } from 'react'
import { RingoverContext } from '../context/RingoverProvider'

function useRingover() {
  return useContext(RingoverContext)
}

export default useRingover
